import { EProjectFilters } from './types';

import { cexPairOrdersFiltersScheme } from '../cex_pair/orders';
import { cexPairTradesFiltersScheme } from '../cex_pair/trades';
import { IFilterSchemeExtended } from '../common';

const omitAccountsField = (scheme: Record<string, IFilterSchemeExtended>) => {
  const { accounts: _accounts, ...rest } = scheme;

  return rest;
};

export const projectFiltersScheme = ({
  type,
  isAdmin,
}: {
  type: EProjectFilters;
  isAdmin?: boolean;
}): Record<string, IFilterSchemeExtended> | undefined => {
  switch (type) {
    case EProjectFilters.cexOrders:
      return omitAccountsField(cexPairOrdersFiltersScheme({ isAdmin }));
    case EProjectFilters.cexTrades:
      return omitAccountsField(cexPairTradesFiltersScheme());
    default:
      return undefined;
  }
};
